import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import EmployeeStatusTable from '../companies/components/EmployeeStatusTable';

export default function EmployeeStatusModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxH="95vh">
        <ModalHeader>סטטוס עובדים בחברות</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <EmployeeStatusTable />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
